var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "38%"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto",
      "display": "block",
      "z-index": "2",
      "margin-top": "-82px",
      "width": "30%",
      "padding-top": "10px",
      "margin-bottom": "15px"
    },
    attrs: {
      "src": require('@/assets/logo.png')
    }
  }), _vm._v(" "), _c('form', {
    ref: "form",
    attrs: {
      "id": "sign_in",
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doReset($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('formline', {
    ref: "email",
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Email",
      "required": "",
      "autofocus": ""
    },
    model: {
      value: (_vm.login.email),
      callback: function($$v) {
        _vm.$set(_vm.login, "email", $$v)
      },
      expression: "login.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('formline', {
    ref: "password",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password",
      "required": "",
      "autofocus": ""
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.$set(_vm.login, "password", $$v)
      },
      expression: "login.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('formline', {
    ref: "repassword",
    attrs: {
      "type": "password",
      "name": "repassword",
      "placeholder": "Ulangi Password",
      "required": "",
      "autofocus": ""
    },
    model: {
      value: (_vm.login.repassword),
      callback: function($$v) {
        _vm.$set(_vm.login, "repassword", $$v)
      },
      expression: "login.repassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto",
      "display": "block",
      "text-align": "center"
    }
  }, [_c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn bg-pink btn-block waves-effect waves-button",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "disabled": _vm.isLoading
    }
  }, [(!_vm.isLoading) ? _c('span', [_vm._v("Reset Password")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading")])])])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticStyle: {
      "color": "#333",
      "font-size": "28px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Admin"), _c('b', [_vm._v("DAPENBI")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("email")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#fff"
    }
  }, [_c('p', [_vm._v("copyright 2018 | Dana Pensiun Indonesia")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#fff"
    }
  }, [_c('p', [_vm._v("Designed by "), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "http://birutekno.com/"
    }
  }, [_vm._v("Birutekno Inc")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52f2d990","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
// module id = AJLC
// module chunks = 1